"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionHighchartsCalculations = void 0;
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const highcharts_1 = __importDefault(require("highcharts"));
const RetentionCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionCalculations");
const lodash_1 = __importDefault(require("lodash"));
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const CommonTypesI18N_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesI18N");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const HighchartsThemeFacade_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsThemeFacade");
const HighchartsOptionsProviderCommon_1 = require("src/hello_assets/src/util/HighchartsOptionsProviderCommon");
const optionsFor = (params) => {
    const request = params.request;
    const response = params.response;
    if (!request || !response) {
        return { options: {} };
    }
    // console.log("Retention calculations with:", params);
    const intervalName = CommonTypesI18N_1.CommonTypesI18N.retentionType.retentionTypeTypeToIntervalName(CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeToRetentionTypeType(request.retentionType));
    const title = params.isOvertimeChart ?
        `N ${intervalName} Retention Overtime` :
        `N ${intervalName} Retention`;
    let xAxisOptions = {};
    if (params.isOvertimeChart) {
        xAxisOptions = {
            ...xAxisOptions,
            dateTimeLabelFormats: DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.xAxis.dateTimeLabelFormats,
            type: 'datetime',
            minTickInterval: 24 * 60 * 60 * 1000,
        };
    }
    else {
        xAxisOptions = {
            ...xAxisOptions,
            allowDecimals: false,
            min: 0,
            labels: {
                formatter: function () {
                    return "" + lodash_1.default.get(response.retentionPeriods, this.pos, this.pos);
                }
            }
        };
    }
    let yAxisOptions = {
        min: 0,
        maxPadding: params.isOvertimeChart ? 0 : undefined,
        title: { text: '' },
        stackLabels: {
            enabled: true,
            style: { fontWeight: 'bold' }
        },
        labels: {
            formatter: function () {
                return this.value + "%";
            }
        }
    };
    if (params.isOvertimeChart) {
    }
    else {
        yAxisOptions.max = 100;
    }
    const legend = {};
    if (params.isOvertimeChart) {
    }
    else {
    }
    const tooltip = {
        useHTML: true,
        shared: true,
        formatter: function () {
            const x = this.x;
            const dateCorrected = new Date(x).getTime();
            const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, dateCorrected);
            if (params.isOvertimeChart) {
                let pointsTableHTML = HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableOpen();
                lodash_1.default.each(this.points, ctx => {
                    // @ts-ignore
                    const { day, cohortSizes, retentionSizes } = ctx.series.options.custom;
                    const pointValue = ctx.y;
                    const resultRetentionSize = retentionSizes[ctx.point.index];
                    const resultCohortSize = cohortSizes[ctx.point.index];
                    pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.pointRow(ctx.color, `${intervalName} ${day}`, `${pointValue}%`, ` (${resultRetentionSize} of ${resultCohortSize})`);
                });
                pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableClose();
                const headerHTML = `<span>${date}</span><br/>`;
                return `${headerHTML}${pointsTableHTML}`;
            }
            else {
                const periodIntervalName = lodash_1.default.get(response.retentionPeriods, x, x);
                const period = `${intervalName} ${periodIntervalName}`;
                let pointsTableHTML = HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableOpen();
                lodash_1.default.each(this.points, ctx => {
                    // @ts-ignore
                    const { isAvg, retentionSizes } = ctx.series.options.custom;
                    const pointValue = ctx.y;
                    const retentionSize = retentionSizes[ctx.point.index];
                    if (isAvg) {
                        // @ts-ignore
                        const { totalCohortSizes, significantRetentionCounts } = ctx.series.options.custom;
                        const significantRetentionCount = significantRetentionCounts[x];
                        const totalCohortSize = totalCohortSizes[ctx.point.index];
                        const resultRetentionSize = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(retentionSize / significantRetentionCount, 2);
                        const resultCohortSize = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(totalCohortSize / significantRetentionCount, 2);
                        pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.pointRow(ctx.color, "AVG", `${pointValue}%`, ` (${resultRetentionSize} of ${resultCohortSize})`);
                    }
                    else {
                        // @ts-ignore
                        const { date, cohortSize } = ctx.series.options.custom;
                        pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.pointRow(ctx.color, date, `${pointValue}%`, ` (${retentionSize} of ${cohortSize})`);
                    }
                });
                pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableClose();
                const headerHTML = `<b>${period}</b><br/>`;
                return `${headerHTML}${pointsTableHTML}`;
            }
        }
    };
    const calculateSeriesResult = params.isOvertimeChart ? RetentionCalculations_1.RetentionCalculations.calculateOvertimeSeries(request, response, params.filterPeriod) : RetentionCalculations_1.RetentionCalculations.calculateClassicSeries(request, response, params.filterCohortDays);
    if (!!process.env.IS_TEST_SERVER) {
        console.log("calculateSeriesResult", calculateSeriesResult);
    }
    const seriesList = calculateSeriesResult.series;
    let subtitle = undefined;
    if (params.shouldAddPeriod && !params.isOvertimeChart) {
        const initialDateMillis = response.intervalStartTimeSec * 1000;
        const initialMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(initialDateMillis).startOf("day");
        const dateFrom = DateTimeFacade_1.DateTimeFacade.Formatters.HumanReadable.Common.formatToDateLocalizedFormat(initialMoment);
        const dateTo = DateTimeFacade_1.DateTimeFacade.Formatters.HumanReadable.Common.formatToDateLocalizedFormat(DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentTime());
        subtitle = { text: dateFrom + ' - ' + dateTo };
    }
    const options = {
        exporting: {
            filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title)
        },
        chart: { zoomType: "x", },
        title: { text: title },
        subtitle: subtitle,
        xAxis: xAxisOptions,
        yAxis: yAxisOptions,
        tooltip: tooltip,
        series: seriesList,
        legend: legend
    };
    // console.log("retention options", options);
    return {
        options: options,
        chartStatus: calculateSeriesResult.chartStatus
    };
};
const stubOptions = () => {
    const result = optionsFor({
        request: {
            cohortQuery: [{ newUser: null }],
            returnQuery: [{ session: null }],
            periodType: CommonTypesConversions_1.CommonTypesConversions.periodType.fromLastNDays(30),
            retentionType: CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeTypeToRetentionType("nDay")
        },
        response: {
            intervalStartTimeSec: DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDay().startOf("day").subtract(30, "day").valueOf() / 1000,
            // retention: _.range(31).map(v => _.range(32- v).map(v => Math.sinh(v)).reverse()),
            retention: Array.from(lodash_1.default.range(31).map(v => HighchartsCalculationsCommonUtils_1.HighchartsRandomChartGenerator.random2(32 - v, { r3: 5 }).reverse()), v => Int32Array.from(v)),
            // retention: [[2001, 1957, 767, 450, 366, 222, 148, 128, 51], [2089, 2032, 831, 506, 395, 238, 155, 136], [2307, 2252, 909, 574, 399, 267, 169, 151], [2255, 2220, 916, 525, 359, 267, 192, 151], [2174, 2125, 806, 447, 355, 257, 169, 133], [1976, 1928, 694, 455, 337, 230, 170, 152], [1879, 1829, 673, 435, 338, 204, 169, 115], [2137, 2086, 823, 532, 399, 281, 194, 156], [2400, 2335, 931, 590, 423, 270, 204, 155], [2591, 2541, 1035, 662, 524, 326, 217, 83], [2616, 2564, 1048, 641, 456, 355, 229], [2461, 2403, 954, 562, 453, 255, 201], [2283, 2228, 867, 560, 436, 266, 164], [1878, 1818, 750, 439, 353, 230, 148], [2165, 2115, 880, 541, 407, 299, 194], [2463, 2407, 983, 604, 440, 304, 199], [2668, 2609, 1074, 669, 495, 368, 120], [2371, 2319, 969, 624, 487, 318], [2402, 2353, 996, 580, 453, 313], [2445, 2403, 1021, 602, 486, 304], [2692, 2642, 1081, 691, 532, 328], [2927, 2866, 1140, 727, 551, 333], [2842, 2780, 1069, 633, 509, 282], [2611, 2563, 1065, 689, 565, 154], [2584, 2542, 1102, 657, 488], [2439, 2394, 1055, 617, 458], [2456, 2416, 1041, 662, 479], [2295, 2248, 914, 531, 189], [2188, 2154, 835, 262], [2344, 2294, 498], [939, 919]].map(v => {
            //     return _.flatten(v.map(vv => ([vv])))
            // }),
            // retention: D_Retention.retention,
            retentionPeriods: Uint32Array.from(lodash_1.default.range(31))
        },
        isOvertimeChart: false,
        filterPeriod: [],
        filterCohortDays: {
            avg: true,
            daysShift: []
        },
        shouldAddPeriod: false
    });
    lodash_1.default.each(result.options.series, (series, idx) => {
        if (idx === 1) {
            series.color = "#d0d0d0";
        }
        else if (idx === 2) {
            series.color = HighchartsThemeFacade_1.UsergeekHighchartsColors.black;
        }
    });
    return result;
};
const dateToDays = function (date) {
    return Math.ceil(date.getTime() / 86400000);
};
exports.RetentionHighchartsCalculations = {
    dateToDays: dateToDays,
    optionsFor: optionsFor,
    stubOptions: stubOptions,
};
